import {connect} from 'react-redux';
import {Pipette as Component} from './Pipette';
import {
  createPipette,
  setPipetteControlVisibility,
  setHeld,
  setHeldObject,
  showMoveMenu,
  hideAllControls,
  setVol,
  incVol,
  decVol

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("pipettes") &&
     state.notebook.protocolSection.scene.apparatus.pipettes.some(
       pipette => pipette.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].controlsVisible,

      tipAttached: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].tipAttached,
      plungerPosition: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].plungerPosition,
      animatingOut: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].animatingOut,
      currentPlungerPos: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].currentPlungerPos,
      solution: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].solution,
      maxVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].maxVol,
      volume: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volume,
      altText: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].altText,

      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      //aria: ownProps.aria,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPipette: (data) => {
      dispatch(createPipette(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    showMoveMenu: (data) => {
      dispatch(showMoveMenu(data))
    },
    setPipetteControlVisibility: (data) => {
      dispatch(setPipetteControlVisibility(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setVol: (data) => {
      dispatch(setVol(data))
    },
    incVol: (data) => {
      dispatch(incVol(data))
    },
    decVol: (data) => {
      dispatch(decVol(data))
    },

    // dropItem: (positionID, componentID) => {
    //   //dispatch(slideOneDragDrop(positionID, componentID));
    // },
    // removeDropped: (positionID) => {
    //   //dispatch(slideOneRemoveDrop(positionID));
    // },
  };
}

export const Pipette = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
